import { namespace } from 'vuex-class';
import type { DocumentState } from './document.types';

export const Document = namespace('document');
export const documentNamespace = 'document';

export enum DocumentAction {
  LoadDocument = 'loadDocument',
  LoadDocumentSuccess = 'loadDocumentSuccess',
  LoadDocumentFailed = 'loadDocumentFailed',
  LoadDocumentRevisions = 'loadDocumentRevisions',
  LoadDocumentRevisionsSuccess = 'loadDocumentRevisionsSuccess',
  LoadDocumentRevisionsFailed = 'loadDocumentRevisionsFailed',
  LoadEditorImageURLs = 'loadEditorImageURLs',
  LoadEditorImageURL = 'loadEditorImageURL',
  SetRevisionViewedByRecipient = 'setRevisionViewedByRecipient',
  SetRevisionViewedByRecipientSuccess = 'setRevisionViewedByRecipientSuccess',
  SetRevisionViewedByRecipientFailed = 'setRevisionViewedByRecipientFailed',
  LoadEditorRecipientInput = 'loadEditorRecipientInput',
  LoadEditorRecipientInputSuccess = 'loadEditorRecipientInputSuccess',
  LoadEditorRecipientInputFailed = 'loadEditorRecipientInputFailed',
  SetEditorRecipientInput = 'SetEditorRecipientInput',
  SetFocusedRequiredId = 'setFocusedRequiredId',
  CompleteSigning = 'completeSigning',
  UpdateAttachments = 'updateAttachments',
  SetAttachmentView = 'setAttachmentView',
  RejectDocument = 'rejectDocument',
  LoadAfterSign = 'loadAfterSign',
  SendEventLog = 'sendEventLog',
  SendDocumentStatus = 'sendDocumentStatus',
  SetRecipientStatus = 'setRecipientStatus',
  LoadDocumentAttachments = 'loadDocumentAttachments',
  ApproveDocument = 'approveDocument',
  ApproveDocumentSuccess = 'approveDocumentSuccess',
  ExpiredReload = 'expiredReload',
  ForwardToRecipient = 'forwardToRecipient',
  ForwardToRecipientFailed = 'forwardToRecipientFailed',
  ForwardToRecipientSuccess = 'forwardToRecipientSuccess',
  SetForwardStatus = 'setForwardStatus',
  GetPdfUrl = 'getPdfPrintUrl',
  GetPdfUrlSuccess = 'getPdfPrintUrlSuccess',
  GetPdfUrlFailed = 'getPdfPrintUrlFailed',
  SetDocumentStatus = 'setDocumentStatus',
  DownloadDocument = 'downloadDocument',
  DownloadDocumentComplete = 'downloadDocumentComplete',
  DownloadDocumentFailed = 'downloadDocumentFailed',
  UpdateRecipients = 'updateRecipients',
  LoadPartiallySignedFields = 'loadPartiallySignedFields',
}

export enum DocumentMutation {
  SetLoading = 'setLoading',
  SetEditorRecipientInputLoading = 'setEditorRecipientInputLoading',
  SetRevisionsLoading = 'setRevisionsLoading',
  SetRevisionsViewedLoading = 'setRevisionsViewedLoading',
  SetEditorRecipientInput = 'setEditorRecipientInput',
  SetButtonLoading = 'setButtonLoading',
  SetForwarded = 'setForwarded',
  SetDocument = 'setDocument',
  SetImageURL = 'setImageURL',
  SetDocumentRevisions = 'setDocumentRevisions',
  SetFocusedRequiredId = 'setFocusedRequiredId',
  SetDocumentStatus = 'setDocumentStatus',
  SetDocumentSignedDate = 'setDocumentSignedDate',
  SetRecipientStatus = 'setRecipientStatus',
  UpdateRecipients = 'updateRecipients',
  SetAttachmentView = 'setAttachmentView',
  SetDocumentAttachments = 'setDocumentAttachments',
  SetError = 'setError',
  SetPdfUrl = 'setPdfUrl',
  SetIsDownloading = 'setIsDownloading',
  SetWatchEngageVideo = 'setWatchEngageVideo',
  SetPartiallySignedFields = 'setPartiallySignedFields',
}

export enum DocumentGetter {
  ViewableRecipients = 'viewableRecipients',
  RecipientsTurnToSign = 'recipientsTurnToSign',
  MyTurnToSign = 'myTurnToSign',
  CurrentRecipient = 'currentRecipient',
  AreAttachmentsUploading = 'areAttachmentsUploading',
  VideoReminder = 'videoReminder',
}

export const state: DocumentState = {
  isEditorRecipientInputLoading: true,
  isLoading: true,
  revisionsIsLoading: false,
  revisionsViewedLoading: false,
  isButtonLoading: false,
  forwarded: false,
  document: null,
  focusedRequiredId: null,
  uploadingAttachmentIds: [],
  error: false,
  pdfUrl: '',
  isDownloading: false,
  editorRecipientInput: [],
  partiallySignedFields: [],
};
